import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';
import queryString from 'query-string';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as SettingsActions } from 'store/ducks/settings';

import { Page, Panel, Loading, Pagination, Breadcrumbs, Icon, Form } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Configurações', to: '/configs' }, { name: 'Variáveis', to: '' }],
    filter: {
      query: '',
    },
  };

  constructor(props) {
    super(props);

    this.handleSearch = debounce(props.getSettingsRequest, 300);
  }

  componentDidMount() {
    const { filter } = this.state;
    const { location, getSettingsRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getSettingsRequest(page, filter);
  }

  componentDidUpdate(oldProps) {
    const { location, getSettingsRequest } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getSettingsRequest(queryString.parse(location.search).page);
    }
  }

  handleChangeQuery = async e => {
    const { filter } = this.state;
    const { name, value } = e.target;

    await this.setState({ filter: { ...filter, [name]: value } });
    this.handleSearch(1, this.state.filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;
    const { settings } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Variáveis de Configuração</Page.Title>

        <Form.Field className="margin-bottom-20">
          <Form.Label className="search-label">Buscar</Form.Label>
          <Form.Input className="search-input" name="query" value={filter.query} onChange={this.handleChangeQuery} />
          <div className="icon-search">
            <i class="fa fa-search" />
          </div>
        </Form.Field>

        <Panel className="panel-list">
          {!settings.data.length && settings.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {settings.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>nome</th>
                    <th>valor</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!settings.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {settings.data.map((settings, index) => (
                    <tr key={settings.id}>
                      <td>{settings.attributes.name}</td>
                      <td>{settings.attributes.value}</td>
                      <td className="text-right">
                        <Link to={`/configs/settings/${settings.id}/edit`} className="button-icon">
                          <Icon name="eye" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination current={settings.page} total={settings.totals} {...this.props} />
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  settings: state.settings,
});

const mapActions = dispatch => bindActionCreators(SettingsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
